export default class SiteAddtionalSettings {
    AddtionalTerms?: string;
    AddtionalTermsRequired?: number;
}